import React, {
    useCallback, useEffect, useRef, useState,
} from 'react'

import {DropdownNestedMenuContentProps} from './types'
import {dropdownNestedMenuContentWrapper} from './styles'
import {styled} from 'stitches/config'
import {useDropdownMenuContext} from '../DropdownContext/dropdownContext'


const StyledDropdownMenuNestedContentWrapper = styled('div', dropdownNestedMenuContentWrapper)

const DropdownNestedMenuContentView = (props: DropdownNestedMenuContentProps) => {
    const {
        children, direction,
    } = props

    const {isOpen} = useDropdownMenuContext()
    const ref = useRef<HTMLDivElement>(null)
    const [positionStyle, setPositionStyle] = useState<React.CSSProperties>({})

    const updatePosition = useCallback(() => {
        const parent = ref.current?.parentElement
        if (parent) {
            const {
                left: parentLeft, top: parentTop,
            } = parent.getBoundingClientRect()
            const menuWidth = ref.current.offsetWidth ?? 200

            const left = parentLeft - menuWidth - 5
            setPositionStyle({
                left: `${Math.max(0, left - 5)}px`,
                position: 'fixed',
                top: `${parentTop - 10}px`,
                transform: 'none',
            })
        }
    }, [])

    useEffect(() => {
        if (isOpen) {
            updatePosition()

            window.addEventListener('scroll', updatePosition, true)
            window.addEventListener('resize', updatePosition)

            return () => {
                window.removeEventListener('scroll', updatePosition, true)
                window.removeEventListener('resize', updatePosition)
            }
        }
        return undefined
    }, [isOpen, updatePosition])

    return (
        <StyledDropdownMenuNestedContentWrapper
            direction={direction}
            open={isOpen}
            ref={ref}
            style={positionStyle}
        >
            {children}
        </StyledDropdownMenuNestedContentWrapper>
    )
}

export default DropdownNestedMenuContentView
